import { render, staticRenderFns } from "./bind-edit.vue?vue&type=template&id=52132f62&scoped=true&"
import script from "./bind-edit.vue?vue&type=script&lang=js&"
export * from "./bind-edit.vue?vue&type=script&lang=js&"
import style0 from "./bind-edit.vue?vue&type=style&index=0&id=52132f62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52132f62",
  null
  
)

export default component.exports